import { render } from "./Hero.vue?vue&type=template&id=7450e4f9&scoped=true"
import script from "./Hero.vue?vue&type=script&lang=js"
export * from "./Hero.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-7450e4f9"

export default script